import React from 'react';

const PartnerInfo = ({ companyDetails }) => {
    return (
        <>
            {(companyDetails) &&
                <div className=" w-full pb-10 pt-0">

                    <h1 className="font-bold text-lg mb-3 px-2">MD/Chairman/Director/Owners/Partner's Info</h1>

                    <table className="custom-details-table w-full mt-0 mb-2">
                        <tbody>
                            <tr>
                                <td className="font-semibold text-base">Full Name</td>
                                <td className="px-5 text-base">{companyDetails.partner_name}</td>
                            </tr>
                            <tr>
                                <td className="font-semibold text-base">Address</td>
                                <td className="px-5 text-base">{companyDetails.partner_address}</td>
                            </tr>
                            <tr>
                                <td className="font-semibold text-base">Cell Phone</td>
                                <td className="px-5 text-base">{companyDetails.partner_phone}</td>
                            </tr>
                            <tr>
                                <td className="font-semibold text-base">Email</td>
                                <td className="px-5 text-base">{companyDetails.partner_email}</td>
                            </tr>

                        </tbody>
                    </table>

                </div>}
        </>
    );
};

export default PartnerInfo;